import React, { ReactNode, useEffect } from "react";
import { TWebsiteBuilderElement } from "../../../../nodes/element/websiteBuilderElement";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import "./elementDraggable.scss";
import { useWebsiteBuilderToolbarContext } from "../../../websiteBuilderToolbarContext";

interface IElementDraggableProps {
  item: TWebsiteBuilderElement;
  children: ReactNode;
}

interface IElementDraggableDragState {
  isDragging: boolean;
}

export function ElementDraggable(props: IElementDraggableProps) {
  const { item, children } = props;

  const { handleSetToolbarMenuType } = useWebsiteBuilderToolbarContext();

  const [dragState, drag, dragPreview] = useDrag<TWebsiteBuilderElement, unknown, IElementDraggableDragState>(() => {
    return {
      item,
      type: item.type,
      collect: (monitor): IElementDraggableDragState => {
        return {
          isDragging: !!monitor.isDragging(),
        };
      },
    };
  }, [item]);

  useEffect(() => {
    dragPreview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  useEffect(() => {
    if (dragState.isDragging) {
      handleSetToolbarMenuType("none");
    }
  }, [dragState.isDragging, handleSetToolbarMenuType]);

  return (
    <div
      ref={drag}
      className="website-builder-element-draggable"
      style={{ cursor: dragState.isDragging ? "grabbing" : "grab" }}
    >
      {children}
    </div>
  );
}
